import React from 'react';
import { useVisitorTracking } from '../hooks/useVisitorTracking';

const IntroCrafting = () => {
  const { ref } = useVisitorTracking('intro-crafting', {
    threshold: 0.4,
    minDuration: 4
  });

  return (
    <section className="intro-crafting" ref={ref}>
      <div className="crafting-content">
        <h2>CRAFTING UNIQUE<br />DIGITAL EXPERIENCES</h2>
        <p>I specialize in delivering creative and functional solutions, combining design expertise with innovative web development to bring ideas to life.</p>
        <div className="services">
          <div className="service-item">
            <img
              src="/web-development-icon.jpg"
              alt="Icon"
              style={{
                width: '50px',
                height: '50px',
                borderRadius: '50%',
                objectFit: 'cover',
                display: 'block',
                margin: '0 auto 20px',
                border: '2px solid #FF2D55'
              }}
            />
            <h3>WEB DEV</h3>
            <p>Creating responsive, modern websites tailored to meet client needs and goals.</p>
          </div>
          <div className="service-item">
            <img
              src="/branding.jpeg"
              alt="Icon"
              style={{
                width: '50px',
                height: '50px',
                borderRadius: '50%',
                objectFit: 'cover',
                display: 'block',
                margin: '0 auto 20px',
                border: '2px solid #FF2D55'
              }}
            />
            <h3>BRANDING</h3>
            <p>Building strong brand identities that resonate and leave a lasting impression.</p>
          </div>
          <div className="service-item">
            <img
              src="/UI UX.png"
              alt="Icon"
              style={{
                width: '50px',
                height: '50px',
                borderRadius: '50%',
                objectFit: 'cover',
                display: 'block',
                margin: '0 auto 20px',
                border: '2px solid #FF2D55'
              }}
            />
            <h3>UI/UX DESIGN</h3>
            <p>Enhancing usability and aesthetics through well-thought-out interface designs.</p>
          </div>
        </div>
      </div>
      <div className="intro-image-wrapper">
        <div className="intro-image">
          <img src="/Picsart_Pro.png" alt="Chouchane Med Amine - Software Developer" />
        </div>
        <div className="social-links">
          <a href="https://www.linkedin.com/in/chouchane-amine-932324320/">
            <img src="/icons8-linkedin-circled-64.png" alt="Linkedin" />
          </a>
          <a href="https://www.instagram.com/_ami_nos_">
            <img src="/icons8-instagram-64.png" alt="Instagram" />
          </a>
          <a href="https://github.com/aminos555">
            <img src="/icons8-github-64.png" alt="GitHub" />
          </a>
        </div>
        <div className="skills-bar">
          <span>UI/UX DESIGN</span> • <span>DIGITAL CREATIVITY</span> • <span>E-COMMERCE</span>
        </div>
      </div>
    </section>
  );
};

export default IntroCrafting;
